import { handleCreateEmployee } from "../utils/handleCreateEmloyee";
import {
    createCertificateModalInterface,
    setIsAddAgainButtonClicked,
    setIsCreateEmployeeModalOpen,
} from "../CreateEmployeeModalSlice";
import { Dispatch } from "redux";
import { JSX, ReactNode } from "react";

interface Props {
    children: ReactNode;
    formValues?: createCertificateModalInterface["formValues"];
    isAddAgainButtonClicked: boolean;
    dispatch: Dispatch;
    postCreateEmployee: (params: { data: Record<string, unknown> }) => {
        unwrap: () => Promise<unknown>;
    };
}

export const FormWrapper = (props: Props): JSX.Element => {
    const {
        children,
        formValues,
        isAddAgainButtonClicked,
        dispatch,
        postCreateEmployee,
    } = props;

    return (
        <form
            className={"c-create-employee-modal__form"}
            onSubmit={(event) => {
                event.preventDefault();
                handleCreateEmployee({
                    dispatch,
                    postCreateEmployee,
                    formValues,
                }).then((value) => {
                    if (isAddAgainButtonClicked && value === "success") {
                        dispatch(setIsCreateEmployeeModalOpen(true));
                        dispatch(setIsAddAgainButtonClicked(false));
                    }
                });
            }}
        >
            {children}
        </form>
    );
};
